import svgLogo from './svg-logo/svg-logo.component';

customElements.define('svg-logo', svgLogo);
